import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {Button, Modal} from 'react-bootstrap';

import EditAttributesWidget from './EditAttributesWidget';
import EditTaskWidget from './EditTaskWidget';
import NewTaskWidget from './NewTaskWidget';
import Spinner from './Spinner';

import taskActions from '../actions/taskActionCreators';
import userActions from '../actions/userActionCreators';
import userTaskActions from '../actions/userTaskActionCreators';
import projectActions from "../actions/projectActionCreators";
import CopyProjectModal from "./CopyProjectModal";
import roles from "../utils/roles";

require.ensure([], () => {
  require('./PMOProjectListWidget.less');
  require('./ProjectDetails.less')
});

class ProjectDetails extends React.Component {

  constructor(props, context) {
    super(props, context);

    let readOnly = true;
    if (this.props.currentUser.roles.includes("PMO"))
      readOnly = false;
    if (this.props.currentUser.roles.includes("PM")) {
      if (this.props.project.manager.id === this.props.currentUser.id)
        readOnly = false;
      if (this.props.project.coManager1 && this.props.project.coManager1.id === this.props.currentUser.id)
        readOnly = false;
      if (this.props.project.coManager2 && this.props.project.coManager2.id === this.props.currentUser.id)
        readOnly = false;
    }

    this.state = {
      activeTask: null,
      activeTab: 0,
      assignmentVisible: false,
      filteredTasks: this.props.tasks,
      filterText: "",
      newTaskVisible: false,
      readOnly: readOnly,
      projectCopyData: {
        endDate: null,
        customerGroup: null,
        name: props.project.name,
        startDate: null
      },
      showCopyModal: false,
      showModal: false,
      showNewTask: false,
      showActiveTasks: true,
      showClosedTasks: false,
      tasks: this.props.tasks,
      userTasks: this.props.userTasks,
      usersAssigned: this.props.usersAssigned
    };
  }

  // LIFECYCLE METHODS

  componentWillReceiveProps = (nextProps) => {
    this.setState({
      filteredTasks: nextProps.tasks,
      tasks: nextProps.tasks,
      userTasks: nextProps.userTasks,
      usersAssigned: nextProps.usersAssigned
    });
    this.filterTasks(this.state.filterText);
  }

  // EVENT HANDLERS

  handleAssignUsers = (task, users) => {
    users.map(user => this.props.dispatch(userTaskActions.assignUserToTask(task.id, user, user.quota)));

    this.props.dispatch(userActions.loadUsersByTask(task.id));
  }

  handleCloseTask = (task) => {
    this.props.dispatch(taskActions.close(task));
  }

  handleConfirmedDelete = () => {
    this.props.dispatch(taskActions.delete(this.state.activeTask));
    this.hideModalDialog();
    this.setState({
      assignmentVisible: false,
      newTaskVisible: false,
      activeTask: null
    });
  }

  handleCopyProjectSubmit = () => {
    const project = {
      ...this.props.project,
      ...this.state.projectCopyData,
      id: null,
      startDate: this.state.projectCopyData.startDate.format("YYYY-MM-DD"),
      endDate: this.state.projectCopyData.endDate ? this.state.projectCopyData.endDate.format("YYYY-MM-DD") : null
    };
    this.props.dispatch(projectActions.create(project));
    this.toggleCopyModal();
  };

  handleDeleteTask = (task) => {
    this.props.dispatch(taskActions.delete(task.id));
    let projectID = task.parent ? task.parent.id : task.parentID;
    setTimeout(() => {
      this.props.dispatch(taskActions.loadByProject(projectID));
    }, 100);
  }

  handleEditTask = (taskID, task) => {
    this.props.dispatch(taskActions.edit(taskID, task));
    this.setState({
      assignmentVisible: false,
      newTaskVisible: false
    });
  }

  handleFilterChange = (event) => {
    this.setState({
        filterText: event.target.value
      },
      this.filterTasks(event.target.value));
  }

  handleNewTask = (task) => {
    this.props.dispatch(taskActions.create(task));

    setTimeout(() => {
      this.props.dispatch(taskActions.loadByProject(this.props.project.id));
    }, 150);
    this.setState({
      newTaskVisible: false
    });
  }

  handleNewTaskClick = (id) => {
    this.setState({
      newTaskVisible: !this.state.newTaskVisible
    });
  }

  handlePillClick = (task) => {
    if (this.state.activeTask && this.state.activeTask.id === task.id) {
      this.setState({
        assignmentVisible: false,
        activeTask: null,
        activeTaskID: -1
      });
      return;
    }

    this.setState({
      assignmentVisible: true,
      activeTask: task,
      activeTaskID: task.id
    });

    this.props.dispatch(userActions.loadUsersByTask(task.id));
    this.props.dispatch(userTaskActions.loadByTask(task.id));
    this.props.dispatch(userActions.loadUsersNoLongerAssigned(task.id));
  }

  handleProjectCopyDataChange = (key, value) => {
    this.setState({
      projectCopyData: {
        ...this.state.projectCopyData,
        [key]: value
      }
    }, () => {
      if (key === "name") {
        this.props.dispatch(projectActions.checkProjectName(value));
      }
    });
  };

  handleRemoveTask = () => {
    this.setState({
      showModal: true
    });
  }

  handleReopenTask = (taskID) => {
    setTimeout(() => {
      this.props.dispatch(taskActions.reopen(taskID));
    }, 50);
    this.props.dispatch(taskActions.loadByProject(this.props.project.id));
  }

  handleShowClosedChange = () => {
    this.setState({
      showClosedTasks: !this.state.showClosedTasks
    });
  }

  handleShowDetails = () => {
    this.props.handleFullDetails();
  }

  handleShowOpenChange = () => {
    this.setState({
      showActiveTasks: !this.state.showActiveTasks
    });
  }

  handleUnassignUsers = (task, userTasks) => {
    userTasks.map(userTask => {
      this.props.dispatch(userTaskActions.unassignUserFromTask(userTask.id));
    });

    this.props.dispatch(userActions.loadUsersByTask(task.id));
  }

  // OTHER METHODS

  clearFilter = () => {
    this.setState({
      filteredTasks: this.state.tasks,
      filterText: ""
    });
  }

  closeNewTaskModal = () => {
    this.setState({
      showNewTask: false
    });
  }

  deleteUserTasks(taskID, users) {
    this.props.deleteUserTasks(taskID, users);
  }

  filterTasks = (input) => {
    let filter = new RegExp(input, 'i');

    this.setState({
      filteredTasks: this.state.tasks.filter(task => filter.test(task.name))
    });
  }

  hideModalDialog = () => {
    this.setState({
      showModal: false
    });
  }

  openNewTaskModal = () => {
    this.setState({
      showNewTask: true
    });
  }

  setActiveTab = (index) => {
    this.setState({
      activeTab: index
    });
  }

  toggleCopyModal = () => {
    if (!this.state.showCopyModal) {
      this.props.dispatch(projectActions.checkProjectName(this.state.projectCopyData.name));
    } else {
      this.props.dispatch(projectActions.clearError());
    }
    this.setState({showCopyModal: !this.state.showCopyModal});
  };

  // RENDER METHOD

  render = () => {
    // TODO there is no option to delete a task
    let modal = (
      <Modal show={true} title={<h3>Confirm task deletion</h3>}>
        <div className="modal-body">
          Are you sure you want to delete task {this.state.activeTask ? this.state.activeTask.name : ""} ?
        </div>
        <div className="modal-footer">
          <Button onClick={this.handleConfirmedDelete}>Yes</Button>
          <Button onClick={this.hideModalDialog}>No</Button>
        </div>
      </Modal>
    );

    let newTaskModal = (
      <NewTaskWidget
        handleClose={this.closeNewTaskModal}
        handleSave={this.handleNewTask}
        parent={this.props.project}
        taskNames={this.props.taskNames}
      />
    );

        if (this.state.activeTab === 1) {
            return (
              <div>
                <div className="main">
                  <div className="row project">
                    <div className="col-lg-10 col-lg-offset-1 col-md-12">
                      <h3 style={{backgroundColor : this.props.project.defaultColor, wordWrap : "break-word"}}>{this.props.project.name}</h3>
                      {
                         roles.userHasAnyOfRoles(JSON.parse(localStorage.getItem('user')), ['PMO']) &&
                          <button title="Copy project" type="button" className="btn btn-default btn-sm" onClick={this.toggleCopyModal}>Copy project</button>
                      }
                    </div>
                  </div>
                </div>
                <CopyProjectModal
                  nameError={this.props.projectsError}
                  handleClose={this.toggleCopyModal}
                  handleProjectDataChange={this.handleProjectCopyDataChange}
                  projectData={this.state.projectCopyData}
                  show={this.state.showCopyModal}
                  handleSubmit={this.handleCopyProjectSubmit}/>
                <EditAttributesWidget
                      handleArchiveProject={this.props.handleArchiveProject}
                      handleUnarchiveProject={this.props.handleUnarchiveProject}
                      handleDeleteProject={this.props.handleDeleteProject}
                      handleSave={this.props.handleEditProject}
                      project={this.props.project}
                      projectNames={this.props.projectNames}
                      refreshProjects={this.props.refreshProjects}
                      setActiveTab={this.setActiveTab}
                      />
              </div>
            );
        } else {
        return (
          <div>
        <div className="main">
            {
              this.state.showNewTask ? newTaskModal : null
            }
            <CopyProjectModal
              nameError={this.props.projectsError}
              handleClose={this.toggleCopyModal}
              handleProjectDataChange={this.handleProjectCopyDataChange}
              projectData={this.state.projectCopyData}
              show={this.state.showCopyModal}
              handleSubmit={this.handleCopyProjectSubmit}/>
                <div className="row project">
                    <div className="col-lg-10 col-lg-offset-1 col-md-12">
                        <h3 style={{backgroundColor : this.props.project.defaultColor, wordWrap : "break-word"}}>
                            {this.props.project.name}
                        </h3>
                      {
                        roles.userHasAnyOfRoles(JSON.parse(localStorage.getItem('user')), ['PMO']) &&
                          <button title="Copy project" type="button" className="btn btn-default btn-sm" onClick={this.toggleCopyModal}>Copy project</button>
                      }
                    </div>
            </div>
          </div>
          <div className="main main-project-details">
            <div className="row project">
              <div className="col-lg-10 col-lg-offset-1 col-md-12">
                <div role="tabpanel">
                  <ul className="nav nav-tabs">
                    <li title="Tasks on project" role="presentation" className="active">
                      <a style={{"cursor": "pointer"}} onClick={this.setActiveTab.bind(this, 0)}
                         aria-controls="project-tasks" role="tab" data-toggle="tab">Project Tasks</a>
                    </li>
                    <li title="Project settings and attributes" role="presentation">
                      <a style={{"cursor": "pointer"}} onClick={this.setActiveTab.bind(this, 1)}
                         aria-controls="project-details" role="tab" data-toggle="tab">Project Details</a>
                    </li>
                  </ul>
                  <div className="tab-content">
                    <div role="tabpanel" className="tab-pane active" id="project-tasks">
                      <div className="clearfix">
                        {this.props.project.archived || this.state.readOnly
                          ? null
                          : <button title="Add new task to project" className="btn btn-default btn-sm btn-right"
                                    type="button" data-toggle="modal" onClick={this.openNewTaskModal}>Add New
                            Task</button>
                        }
                      </div>
                      <div className="row">
                        <div className="col-md-9 col-lg-6">
                          <div className="panel-filter">
                            <div className="form-group">
                              <label>Filter:</label>
                              <input value={this.state.filterText} onChange={this.handleFilterChange} type="text"
                                     className="form-control" placeholder="Task Name"/>
                              <a style={{"cursor": "pointer", paddingRight: "10px", paddingTop: "5px"}}
                                 onClick={this.clearFilter} className="filter-clear">
                                                        <span>
                                                            <span className="md-clear"></span>
                                                        </span>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-3 col-lg-6" style={{marginTop: "5px"}}>
                          <label>
                            <input type="checkbox" checked={this.state.showActiveTasks}
                                   onChange={this.handleShowOpenChange}/>
                            &nbsp;Active
                          </label>
                          &nbsp;&nbsp;&nbsp;&nbsp;
                          <label>
                            <input type="checkbox" checked={this.state.showClosedTasks}
                                   onChange={this.handleShowClosedChange}/>
                            &nbsp;Closed
                          </label>
                        </div>
                      </div>
                      {
                        this.props.tasksLoading
                          ? <span><br/><Spinner/></span>
                          : this.state.filteredTasks.map((task, i) => {
                            if (!this.state.showActiveTasks && task && task.closed === false) {
                              return null;
                            }

                            if (!this.state.showClosedTasks && task && task.closed) {
                              return null;
                            }

                            return <EditTaskWidget
                              active={this.state.activeTask && this.state.activeTask.id === task.id}
                              approver={task.approver == this.props.approver ? null : task.approver}
                              approverName={task.approverName == this.props.approverName ? "" : task.approverName}
                              color={this.props.project.defaultColor}
                              description={task.description}
                              handleAssign={this.handleAssignUsers}
                              handleClose={this.handleCloseTask}
                              handleClick={this.handlePillClick}
                              handleDelete={this.handleDeleteTask}
                              handleReopen={this.handleReopenTask}
                              handleSave={this.handleEditTask}
                              handleUnassign={this.handleUnassignUsers}
                              id={i}
                              key={i * 1000}
                              taskId={task.id}
                              name={task.name}
                              project={this.props.project}
                              privateDescription={task.privateDescription}
                              taskEditing={task}
                              taskNames={this.props.taskNames}
                              taskQuota={task.taskQuota}
                              //userTasksAssigned={this.state.userTasks}
                              usersAssigned={this.state.usersAssigned}
                              billable={task.billable}
                            />;
                          })
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
}

ProjectDetails.propTypes = {
  approver: PropTypes.string,
  approverName: PropTypes.element,
  attributes: PropTypes.array,
  coPmsAssigned: PropTypes.array,
  currentUser: PropTypes.object,
  deleteUserTasks: PropTypes.func,
  dispatch: PropTypes.func,
  endDate: PropTypes.string,
  handleFullDetails: PropTypes.func,
  handleEditProject: PropTypes.func,
  handleDeleteProject: PropTypes.func,
  manager: PropTypes.string,
  managerName: PropTypes.array,
  project: PropTypes.object,
  projectsLoading: PropTypes.bool,
  projectNames: PropTypes.array,
  refreshProjects: PropTypes.object, //TODO determine type
  setAttributes: PropTypes.array,
  sponsor: PropTypes.string,
  sponsorName: PropTypes.string,
  sponsorUsers: PropTypes.array,
  startDate: PropTypes.string,
  tasks: PropTypes.array,
  taskAddedHandler: PropTypes.func,
  taskNames: PropTypes.array,
  tasksLoading: PropTypes.bool,
  users: PropTypes.array,
  userTasks: PropTypes.array,
};

ProjectDetails.defaultProps = {
  userTasks: [],
};

const mapStateToProps = (state) => {
  return {
    attributes: state.attributes.attributes,
    currentUser: state.users.currentUser,
    projectsError: state.projects.error,
    projectsLoading: state.projects.loading,
    tasksLoading: state.tasks.loading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch: dispatch
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProjectDetails);



/** WEBPACK FOOTER **
 ** ./src/app/components/ProjectDetails.js
 **/